// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__oIzjn","img":"Icon_img__9x7pd","vec":"Icon_vec__QLdem"};